import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getAuthCredentials() {
  const response = await defaultFetch('/AuthConfig');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response;
}

export function useAuthCredentials() {
  return useQuery({
    queryKey: ['auth-credentials'],
    staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week
    queryFn: async () => getAuthCredentials()
  });
}
